import { useEffect, useRef } from 'react';

const WS_URL = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, 'ws')}/api/rp/ws`;

// Tempo real da RECARGA PREMIADA: o servidor avisa (recarga, baú aberto, fila, entrega) e a página recarrega o estado.
// Reconecta sozinho; ping a cada 25s. onEvent(type, data) é chamado para cada evento.
export const useRpSocket = (onEvent) => {
  const cb = useRef(onEvent);
  cb.current = onEvent;
  useEffect(() => {
    let alive = true, ws = null, ping = null, retry = null;
    const connect = () => {
      if (!alive) return;
      const tok = localStorage.getItem('customer_token') || '';
      try {
        ws = new WebSocket(`${WS_URL}?token=${encodeURIComponent(tok)}`);
      } catch { retry = setTimeout(connect, 5000); return; }
      ws.onopen = () => { ping = setInterval(() => { try { ws.send(JSON.stringify({ t: 'ping' })); } catch { /* noop */ } }, 25000); };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg.type && msg.type !== 'rp.pong' && msg.type !== 'rp.hello') cb.current?.(msg.type, msg.data || {});
        } catch { /* noop */ }
      };
      ws.onclose = () => { if (ping) clearInterval(ping); if (alive) retry = setTimeout(connect, 4000); };
      ws.onerror = () => { try { ws.close(); } catch { /* noop */ } };
    };
    connect();
    return () => { alive = false; if (ping) clearInterval(ping); if (retry) clearTimeout(retry); try { ws?.close(); } catch { /* noop */ } };
  }, []);
};

export default useRpSocket;
